import Address from 'src/models/Address';
import IOwner from 'src/models/IOwner';
import PhoneNumberChanges from 'src/models/PhoneNumberChanges';

export default class OwnerIndividual implements IOwner {
    constructor(owner: OwnerIndividual) {
        Object.assign(this, owner);
    }

    id: number;
    ownerType: string;
    personDetailsId: number;
    containerOwnerId: number;
    ownerLookUpId: number;
    prefix: string;
    firstName: string;
    lastName: string;
    middleName: string;
    suffix: string;
    aka: string;
    spousePrefix: string;
    spouseLastName: string;
    spouseMiddleName: string;
    spouseFirstName: string;
    spouseSuffix: string;
    spouseAka: string;
    maritalStatus: string;
    maritalStatusId: number;
    address: Address;
    addressInformationDate: Date;
    phoneNumberChanges?: PhoneNumberChanges;
    email: string;
    note: string;
    isPrimaryDeviation: boolean;
    isClientAcreage: boolean;
    ssnTaxId: string;

    ownerName = () => {
        let name: string;
        if (this.maritalStatus === 'married') {
            name = this.firstName + ' ' + this.lastName + ' and spouse, ' + this.spouseFirstName + ' ' + this.spouseLastName;
        } else {
            name = this.firstName + ' ' + this.lastName;
        }
        return name;
    };
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/add_ownership_revised/OwnerIndividual.ts